import React, { useState } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons"

import Icon from "../layout/icon"
import Card from "../layout/card"
import Radio from "../Radio/Radio"
import TextBox from "../TextBox/TextBox"
import ButtonLink from "../ButtonLink/ButtonLink"
import ReviewWidget from "../ReviewWidget/ReviewWidget"
import PageHeadingText from "../PageHeadingText/PageHeadingText"
import { MediumAndUp } from "../layout/Responsive/Responsive"
import { BROWSE_SEARCH_PATH } from "../../utils/paths"

import {
  centredWhenVisible,
  error as errorStyles,
  row as rowStyles,
  searchCard,
  search as searchStyles,
} from "./styles.module.scss"

const buildSearchLink = (search, careType, careServiceType) => {
  const careServiceTypeParam =
    careServiceType && careType === "care_home"
      ? `&care_provided[]=${careServiceType}`
      : ""

  return `${BROWSE_SEARCH_PATH}?location=${search}&care_type=${careType}${careServiceTypeParam}`
}

const Search = ({
  careType,
  locationName,
  pageType,
  currentUrl,
  careServiceType,
}) => {
  const [selectedCareType, setSelectedCareType] = useState(
    careType || "care_home",
  )
  const [search, setSearch] = useState("")
  const [error, setError] = useState(false)

  const setHasError = () => setError(true)
  const clearError = () => setError(false)
  const handleUpdateSearch = (value) => {
    setSearch(value)
    clearError()
  }
  const searchLink = buildSearchLink(search, selectedCareType, careServiceType)
  const disableSearchLink = !search

  const searchButtonEvent = {
    name: `SEO - ${pageType} - Search Button Click`,
    properties: {
      "Care Type": careType,
      "Geo Location": locationName,
      "Current URL": currentUrl,
    },
  }

  return (
    <Card noMarginAbove noMarginBelow extraClasses={classNames(searchCard)}>
      <PageHeadingText
        careType={careType}
        locationName={locationName}
        careServiceType={careServiceType}
      />
      <Radio
        name="caretype"
        value="care_home"
        label="Care homes"
        onChange={setSelectedCareType}
        checked={selectedCareType === "care_home"}
      />
      <Radio
        name="caretype"
        value="home_care"
        label="Home care"
        onChange={setSelectedCareType}
        checked={selectedCareType === "home_care"}
      />
      <div className={classNames(rowStyles)}>
        <TextBox
          hasErrors={error}
          placeholder='e.g. "Newcastle" or "SW1A 1AA"'
          value={search}
          onChange={handleUpdateSearch}
          label="Search for care by entering a place name or postcode"
        />
        {error && (
          <span className={errorStyles}>
            <Icon icon={faExclamationCircle} /> Please enter a postcode to
            search
          </span>
        )}
      </div>
      <div className={classNames(rowStyles)}>
        <ButtonLink
          disabled={disableSearchLink}
          onDisabledClick={setHasError}
          noChevron
          fullWidth
          to={searchLink}
          clickEvent={searchButtonEvent}
        >
          <span className={classNames(searchStyles)}>
            <Icon icon={faSearch} />
            Search
          </span>
        </ButtonLink>
      </div>
      <MediumAndUp className={classNames(centredWhenVisible)}>
        <ReviewWidget />
      </MediumAndUp>
    </Card>
  )
}

Search.propTypes = {
  careType: PropTypes.oneOf(["home_care", "care_home"]),
  locationName: PropTypes.string,
  pageType: PropTypes.oneOf(["Filtered Directory", "Location Directory"])
    .isRequired,
  currentUrl: PropTypes.string.isRequired,
  careServiceType: PropTypes.oneOf(["dementia"]),
}

Search.defaultProps = {
  careType: undefined,
  locationName: undefined,
  careServiceType: undefined,
}

export default Search
